import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["page", "location", "children", "use", "onClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { getCommerceHomeUrl } from '../../urls/urls';
import { events } from '../../usage-tracker/events';
import { track } from '../../usage-tracker/track';
import { useGoToPaymentsButtonType } from './useGoToPaymentsButtonType';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
// IMPORTANT: DO NOT add View tracking to this button as long as this is rendered in the CRM record page.
// Slack ref - https://hubspot.slack.com/archives/C021VAHKM61/p1711041268391919
const GoToPaymentsButton = _ref => {
  let {
      page,
      location = '',
      children,
      use,
      onClick
    } = _ref,
    passthroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const buttonType = useGoToPaymentsButtonType();
  const getTrackingData = useCallback(() => ({
    location: page,
    value: location,
    referrerUrl: document.referrer
  }), [page, location]);
  const handleClick = event => {
    track(events.paymentSettingsInteraction, Object.assign({
      action: 'goToZeroStateButtonClicked'
    }, getTrackingData()));
    if (onClick) {
      onClick(event);
    }
  };
  if (!buttonType) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, Object.assign({
    rel: "noopener" // override the rel attribute to remove the "noreferrer" tag, slack ref - https://hubspot.slack.com/archives/CEZNHE030/p1696003611704799
    ,
    "data-test-id": `go-to-payments-button-${location}`,
    onClick: handleClick,
    use: use || 'tertiary',
    href: getCommerceHomeUrl()
  }, passthroughProps, {
    children: children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: `growthPaymentsCore.goToPaymentsButton.${buttonType}`
    })
  }));
};
export default GoToPaymentsButton;